import { render, staticRenderFns } from "./DispatchDetailsAssetView.vue?vue&type=template&id=322fc218&scoped=true"
import script from "./DispatchDetailsAssetView.vue?vue&type=script&lang=js"
export * from "./DispatchDetailsAssetView.vue?vue&type=script&lang=js"
import style0 from "./DispatchDetailsAssetView.vue?vue&type=style&index=0&id=322fc218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322fc218",
  null
  
)

export default component.exports